var map = {
	"./d-0.png": "teV2",
	"./d-1.png": "wvyM",
	"./d-2.png": "C/sE",
	"./d-3.png": "P9a3",
	"./d-4.png": "XYqs",
	"./d-5.png": "Whip"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "oGYM";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3 ^\.\/d\-.*\.png$
// module id = oGYM
// module chunks = 1